@if (isHomeMeetingOnly) {
	<app-home-meeting
		[followup]="followup"
		isModalMode
		[groupAttendRowPatientId]="groupAttendRowPatientId"
		(moveToOtherFollowup)="moveToOtherFollowup.emit($event)"
		(addDocumentEv)="addMedicalLetter()"
		(addInvoiceEv)="addInvoice()"
		(openUploadDocumentModalEv)="modalProps = { name: 'upload-document' }"
	>
		<ng-container patientImages>
			<button
				class="btn btn-primary"
				titleLang="see_all_patient_images"
				(click)="getPatientImages()"
				preIcon="image"
			>
				{{ "see_all_patient_images" | langVal }}
			</button>
		</ng-container>
	</app-home-meeting>
} @else {
	@if (!isHome) {
		<app-mobile-tabs
			[activeColumn]="showColumn"
			personType="patient"
			(onClick)="updateShowColumnLocal($event)"
		/>
	}

	<app-banner
		[isLoading]="isLoading"
		[person]="patient"
		[time]="$safeNavigationMigration(followup?.time)"
		(onClick)="changeCurCenterToPatientDetails()"
	/>

	<div class="person-content swipe-parent">
		<!-- comments for side scrolling:
        <div class="row person-content"  [style.width]="(sideWidth*2)+'px'" >
          <div class="col-6 col-lg-8 center-area" #center> -->

		<!-- <div
			[hidden]="
				eventsService.isMobile &&
				(showColumn | inArray: ['calendar', 'sideItems'])
			"
            class="center-area"
            #center
            > -->
		<div
			class="center-area swipe-child"
			#center
		>
			<!--side-scroll -->
			@if (isLoading || (!followup && isHome && !curCenter)) {
				<div class="panel panel-default center">
					<div class="panel-heading"></div>
					<div class="panel-body no-followup-container">
						@if (isLoading) {
							<div
								class="loading-spinner"
								spin
							></div>
						} @else {
							<p class="no-followup-title">
								@switch (timeStatus) {
									@case ("past") {
										<span
											[innerHTML]="
												'there_are_no_followups_past' | langVal | safeHtml
											"
										></span>
									}
									@case ("present") {
										<span
											[innerHTML]="
												'there_are_no_followups_present' | langVal | safeHtml
											"
										></span>
									}
									@case ("future") {
										@if (dayEventsLength) {
											<span
												[innerHTML]="
													'there_are_no_followups_but_fus_future'
														| langVal
														| safeHtml
												"
											></span>
										} @else {
											<span
												[innerHTML]="
													'there_are_no_followups_future' | langVal | safeHtml
												"
											></span>
										}
									}
								}
							</p>
							@if (timeStatus != "past") {
								<p
									class="no-followup-title"
									style="margin-top: 20px"
								>
									<span
										[innerHTML]="
											'there_are_no_followups_click_to_set' | langVal | safeHtml
										"
									></span>
								</p>
							}
						}
						<!-- {{(isLoading ? "loading" : "there_are_no_followups") | langVal}} -->
					</div>
				</div>
			}
			@if (!isLoading && patient) {
				@switch (curCenter) {
					@case ("patient_details") {
						<div class="panel panel-default">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<div class="gen-tbl-header-top">
									<h4
										class="gen-title"
										[titleLang]="patient.is_group == 'no' ? 'patient' : 'group'"
									>
										{{
											(patient.is_group == "no"
												? "patient_details"
												: "group_details"
											) | langVal
										}}
									</h4>
								</div>
								@if (patient.is_group == "no") {
									<app-update-patient
										[patient]="patient"
										(addDocumentEv)="addDocument()"
										(addInvoiceEv)="addInvoice()"
										(openUploadDocumentModalEv)="
											modalProps = { name: 'upload-document' }
										"
									/>
								} @else {
									<app-update-group [group]="patient" />
								}
							</div>
						</div>
					}
					@case ("contactway") {
						<div class="panel panel-default panel-contactway">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="contactways"
									(changeHappened)="leftSideUpdate($event, 'contactways')"
								/>
							</div>
						</div>
					}
					@case ("diagppatient") {
						<div class="panel panel-default panel-diagppatient">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<!-- style="direction: ltr"
                            dir="ltr" -->

								<app-gen-table2
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="diagppatients"
									(changeHappened)="leftSideUpdate($event, 'diagppatients')"
								/>
							</div>
						</div>
					}
					@case ("medicpatient") {
						<div class="panel panel-default">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div
								class="panel-body"
								style="direction: ltr"
								dir="ltr"
							>
								<app-gen-table
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="medicpatients"
									(changeHappened)="leftSideUpdate($event, 'medicpatients')"
								>
									<div
										slot="upper-row"
										class="d-flex"
									>
										<button
											titleLang="add_prescription"
											tabindex="-1"
											class="btn btn-primary"
											(click)="requireCompProps = { name: 'prescription' }"
											postIcon="plus"
										>
											<!-- <span>{{"prescription" | langVal}}</span> -->
											{{ "prescription" | langVal }}
										</button>
									</div>
								</app-gen-table>
							</div>
						</div>

						<div class="panel panel-default">
							<div
								class="panel-body"
								style="direction: ltr"
								dir="ltr"
							>
								<app-gen-table
									#prescriptionsTable
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="prescriptions"
									isEditDisabled
								/>
							</div>
						</div>
					}
					@case ("nondrugpatient") {
						<div class="panel panel-default panel-nondrugpatient">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>

							<div class="panel-body">
								<app-gen-table
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="nondrugpatients"
									(changeHappened)="leftSideUpdate($event, 'nondrugpatients')"
								/>
							</div>
						</div>
					}
					@case ("labtestpatient") {
						<div class="panel panel-default panel-labtestpatient">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="labtestpatients"
									(changeHappened)="leftSideUpdate($event, 'labtestpatients')"
								/>
							</div>
						</div>
					}
					@case ("mixed_list") {
						<div class="panel panel-default panel-mixed-list">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body mixed-list-body">
								<app-mixed-list
									#mixedList
									[patient]="patient"
									[followup_id]="$safeNavigationMigration(followup?.id)"
								/>
							</div>
						</div>
					}
					@case ("test") {
						<div class="panel panel-default">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<!-- <div class="d-flex"> -->
								<div class="gen-tbl-header-top">
									<h4 class="gen-title">
										{{ "tests" | langVal }}
									</h4>
								</div>

								<div class="text-end">
									<button
										class="btn btn-primary"
										(click)="modalProps = { name: 'tests-menu' }"
									>
										{{ "open_test_manage" | langVal }}
									</button>
									<button
										class="btn btn-primary"
										(click)="modalProps = { name: 'patient-test-invites' }"
									>
										{{ "test_invites_log" | langVal }}
									</button>
									<button
										class="btn btn-primary"
										(click)="modalProps = { name: 'testschedules' }"
									>
										{{ "test_schedules" | langVal }}
									</button>
								</div>
								<!-- </div> -->
								<div class="row">
									<div class="col-12 items">
										@if (hasCheckedItems) {
											<div
												style="background-color: #edf9eb"
												[spinner]="isSendingMulti"
											>
												<button
													class="btn btn-primary"
													(click)="sendTests()"
												>
													{{ "email_multiple_invoices" | langVal }}
												</button>
												<button
													class="btn btn-primary"
													(click)="printTests()"
												>
													{{ "print_multiple_invoices" | langVal }}
												</button>
											</div>
										}

										<div class="table-responsive">
											<table class="table table-hover">
												<thead>
													<tr>
														@if (permsService.perms?.clinical) {
															<th>
																<app-check
																	(onClick)="
																		testsChooseAllChecked =
																			!testsChooseAllChecked;
																		testsChooseAll()
																	"
																	[isCheck]="testsChooseAllChecked"
																/>
															</th>
														}
														@for (field of ["date", "test"]; track field) {
															<th>{{ field | langVal }}</th>
														}
														@if (permsService.perms?.clinical) {
															@for (
																field of ["answers", "download", "graphs"];
																track field
															) {
																<th>{{ field | langVal }}</th>
															}
														}
													</tr>
												</thead>
												<tbody>
													@for (row of patient.tests; track row.testfill_id) {
														<tr [class.grey]="$odd">
															@if (permsService.perms?.clinical) {
																<td>
																	<app-check
																		(onClick)="
																			row.checked = !row.checked;
																			postTestChoose()
																		"
																		[isCheck]="row.checked"
																	/>
																</td>
															}
															<td>{{ row.date | dateFormat }}</td>
															<td>{{ row.name }}</td>
															@if (permsService.perms?.clinical) {
																<td titleLang="testanswers">
																	@if (
																		row.is_locked == "yes" || row.html_text
																	) {
																		<app-icon
																			icon="map"
																			pointer
																			(click)="row.open = !row.open"
																		/>
																	}
																</td>
																<td>
																	<app-spin-or-content
																		[isSpin]="
																			$safeNavigationMigration(
																				row?.isDownloading
																			)
																		"
																	>
																		<app-icon
																			icon="download"
																			pointer
																			(click)="download_testfill(row)"
																		/>
																	</app-spin-or-content>
																</td>
																<td>
																	@if (
																		row.calculated == "yes" &&
																		row?.hasMultipleFills
																	) {
																		<button
																			class="btn btn-primary"
																			(click)="openTestGraph(row.id)"
																		>
																			{{ "graphs" | langVal }}
																		</button>
																	}
																</td>
															}
														</tr>
														@if (row.open) {
															<tr [class.grey]="$odd">
																<td colspan="999">
																	@if (row.remarks) {
																		<div
																			[innerHTML]="row.remarks | safeHtml"
																		></div>
																	}
																	@if (row.html_text) {
																		<div
																			[innerHTML]="row.html_text | safeHtml"
																		></div>
																	} @else {
																		<app-test-display [test]="row" />
																	}
																</td>
															</tr>
														}
													}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					@case ("reminder") {
						<div class="panel panel-default">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									tableName="notifications"
								/>
							</div>
						</div>
					}
					@case ("invoice") {
						<div class="panel panel-default panel-finresources">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									#finresourceTable
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									isCheckItems
									(checkedItemsChanged)="updateFinResourceIds($event)"
									tableName="finresources"
								/>
								<div class="panel-options">
									<div id="reports-financial">
										<button
											titleLang="follow_ups_report"
											tabindex="-1"
											class="btn btn-primary"
											(click)="openReport('followups_report')"
										>
											{{ "follow_ups_report" | langVal }}
										</button>
										<button
											titleLang="income"
											tabindex="-1"
											class="btn btn-primary"
											(click)="openReport('invoices_report')"
										>
											{{ "income" | langVal }}
										</button>
										@if (
											patient?.is_group != "yes" ||
											patient?.charge_mode == "by_group"
										) {
											<app-btn-ext
												text="debts_report"
												(clickEv)="openReport('debts_report')"
											/>
											@if (permsService.perms?.administrative) {
												<button
													titleLang="bankaccounts"
													tabindex="-1"
													class="btn btn-primary"
													(click)="
														modalProps = { name: 'table-display-bankaccounts' }
													"
												>
													{{ "bankaccounts" | langVal }}
												</button>
											}
										}
									</div>
									@if (
										patient?.is_group != "yes" ||
										patient?.charge_mode == "by_group"
									) {
										<div class="mis-auto">
											@if (permsService.perms?.administrative) {
												<button
													titleLang="invoice_short"
													tabindex="-1"
													class="btn btn-primary"
													(click)="addInvoice()"
													postIcon="plus"
												>
													{{ "invoice_short" | langVal }}
												</button>
											}
											<proforma-send-btn
												[patient]="patient"
												isBy="sms"
											/>
											<proforma-send-btn
												[patient]="patient"
												isBy="whatsapp"
											/>
											<proforma-send-btn
												[patient]="patient"
												isBy="email"
											/>
										</div>
									}
								</div>
							</div>
						</div>
					}
					@case ("document") {
						<div class="panel panel-default panel-documents">
							<div class="panel-head">
								<div class="col-12">
									<ng-container *ngTemplateOutlet="backBtn" />
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									#documentsTable
									filterField="patient_id"
									[filterFieldValue]="patient.id"
									isCheckItems
									(checkedItemsChanged)="updateFinResourceIds($event)"
									tableName="documents"
								/>
								<div class="panel-options">
									<button
										titleLang="letter"
										tabindex="-1"
										class="btn btn-primary"
										(click)="addMedicalLetter()"
										postIcon="plus"
									>
										{{ "medical_letter" | langVal }}
									</button>
									<button
										titleLang="letter"
										tabindex="-1"
										class="btn btn-primary"
										(click)="addDocument()"
										postIcon="plus"
									>
										{{ "letter" | langVal }}
									</button>

									<button
										titleLang="upload_file"
										tabindex="-1"
										class="btn btn-primary"
										(click)="modalProps = { name: 'upload-document' }"
										postIcon="plus"
									>
										{{ "upload_file" | langVal }}
									</button>
									<button
										class="btn btn-primary"
										titleLang="see_all_patient_images"
										(click)="getPatientImages()"
									>
										<!-- preIcon="image">-->

										{{ "see_all_patient_images" | langVal }}
									</button>
								</div>

								<!-- (changeHappened)="leftSideUpdate($event,'documents')" -->
							</div>
						</div>
					}

					@default {
						@if (isHome) {
							@if (followup) {
								<app-home-meeting
									[followup]="followup"
									[groupAttendRowPatientId]="groupAttendRowPatientId"
									(moveToOtherFollowup)="moveToOtherFollowup.emit($event)"
									(addDocumentEv)="addMedicalLetter()"
									(addInvoiceEv)="addInvoice()"
									(openUploadDocumentModalEv)="
										modalProps = { name: 'upload-document' }
									"
								>
									<ng-container patientImages>
										<button
											class="btn btn-primary"
											titleLang="see_all_patient_images"
											(click)="getPatientImages()"
											preIcon="image"
										>
											{{ "see_all_patient_images" | langVal }}
										</button>
									</ng-container>
								</app-home-meeting>
							}
						} @else {
							<div>
								@if (patient.is_group == "no") {
									<app-update-patient
										[patient]="patient"
										(addDocumentEv)="addDocument()"
										(addInvoiceEv)="addInvoice()"
										(openUploadDocumentModalEv)="
											modalProps = { name: 'upload-document' }
										"
									/>
								} @else {
									<app-update-group [group]="patient" />
								}
							</div>
						}
					}
				}
			}
		</div>

		@if (!isLoading && patient) {
			<!-- <div
				[hidden]="
					eventsService.isMobile &&
					(showColumn | inArray: ['calendar', 'center'])
				"
                                                  id="home-side-patient-col"
                                                  class="side-scroll"
                                                  > -->
			<div
				id="side-patient-col"
				class="swipe-child"
				#sideItemsDiv
			>
				@for (sideItem of sideItems; track sideItem) {
					<app-person-side-item
						[color]="color"
						[sideItem]="sideItem"
						[curCenter]="curCenter"
						(click)="sideItemClick(sideItem.name)"
						class="pointer"
					>
						<div class="person-side-items">
							@switch (sideItem.name) {
								@case ("details") {
									@if (patient?.is_group == "yes") {
										<div
											class="row form-group"
											(click)="$event.stopImmediatePropagation()"
										></div>
									}
								}
								@case ("tasks") {
									@for (task of patient.tasks | slice: 0 : 4; track task) {
										<div>
											{{ $any(task).content }}
										</div>
									}
								}
								@case ("contactway") {
									@for (
										contactway of patient.contactways | slice: 0 : 4;
										track contactway
									) {
										<div class="d-flex gap-1">
											<div class="contactway">
												{{ $any(contactway).contactway }}
											</div>
											<div>
												{{
													$any(contactway).name
														? " - " + $any(contactway).name
														: ""
												}}
												{{
													$any(contactway).description
														? " - " + $any(contactway).description
														: ""
												}}
												<!--remember for merge-->
											</div>
										</div>
									}
								}
								@case ("medicpatient") {
									@for (
										medicpatient of patient.medicpatients
											| endDateNull
											| slice: 0 : 4;
										track medicpatient
									) {
										<div style="direction: ltr">
											{{
												medicpatient.medic_name_dec || medicpatient.medic_name
											}}
											{{
												medicpatient.amount +
													"X" +
													medicpatient.frequency +
													"/" +
													medicpatient.frequency_unit
											}}
										</div>
									}
								}
								@case ("nondrugpatient") {
									@for (
										nondrugpatient of patient.nondrugpatients
											| endDateNull
											| slice: 0 : 4;
										track nondrugpatient
									) {
										<div>
											{{
												nondrugpatient.nondrug_name_dec ||
													nondrugpatient.nondrug_name
											}}
										</div>
									}
								}
								@case ("diagppatient") {
									@for (
										diagppatient of patient.diagppatients
											| endDateNull
											| slice: 0 : 8;
										track diagppatient
									) {
										<div style="direction: ltr">
											{{
												diagppatient.diagp_name_dec || diagppatient.diagp_name
											}}
										</div>
									}
								}
								@case ("labtestpatient") {
									@for (
										labtestpatient of patient.labtestpatients | slice: 0 : 4;
										track labtestpatient
									) {
										<div style="direction: ltr">
											{{
												$any(labtestpatient).labtest_name_dec ||
													$any(labtestpatient).labtest_name
											}}
										</div>
									}
								}
								@case ("mixed_list") {
									<div>
										{{ ("last_meeting" | langVal) + ": " }}
										{{ patient.last_followup }}
									</div>
									<div>
										{{ ("next_meeting" | langVal) + ": " }}
										{{ patient.next_followup }}
									</div>
								}
								@case ("reminder") {
									@for (
										notification of patient.notifications | slice: 0 : 4;
										track notification
									) {
										<div>
											{{
												$any(notification).message_dec ||
													$any(notification).message
											}}
										</div>
									}
								}
								@case ("test") {
									@for (test of patient.tests | slice: 0 : 4; track test) {
										<div class="document-div">
											<div class="col">{{ $any(test).name }}</div>
											<div class="col text-end">
												{{ $any(test).date | dateFormat }}
											</div>
										</div>
									}
								}
								@case ("invoice") {
									@if (
										patient?.is_group != "yes" ||
										patient?.charge_mode == "by_group"
									) {
										<div class="totals-format">
											<div>
												{{
													("total_lm_prices" | langVal) +
														" " +
														(lastMonth | langVal) +
														": "
												}}
												<span>{{ patient.total_lm_prices | finNumber }}</span>
											</div>
											@if (patient.payor_id) {
												<div>
													{{
														("total_lm_payor_prices" | langVal) +
															" " +
															(lastMonth | langVal) +
															": "
													}}
													<span>{{
														patient.total_lm_payor_prices | finNumber
													}}</span>
												</div>
											}
											<div>
												{{
													("total_until_lm_debt" | langVal) +
														" " +
														(lastMonth | langVal) +
														": "
												}}
												<span>{{
													patient.total_until_lm_debt < 0
														? 0
														: (patient.total_until_lm_debt | finNumber)
												}}</span>
											</div>
											@if (patient.total_total_debt >= 0) {
												<div>
													{{ ("total_total_debt" | langVal) + ": " }}
													<span>{{
														patient.total_total_debt | finNumber
													}}</span>
												</div>
											} @else {
												<div>
													{{
														("total_total_credit" | langVal) +
															patient.name +
															": "
													}}
													<span>{{
														-patient.total_total_debt | finNumber
													}}</span>
												</div>
											}
										</div>
									}
								}
								@case ("document") {
									@for (
										document of patient.documents | slice: 0 : 4;
										track document
									) {
										<div class="document-div">
											<div class="col">
												{{ $any(document).title_dec || $any(document).title }}
											</div>
											<div class="col text-end">
												{{ $any(document).date | dateFormat }}
											</div>
										</div>
									}
								}
								@case ("patient_remark") {
									<div [innerHtml]="patient.remarks | safeHtml"></div>
								}
							}
						</div>
					</app-person-side-item>

					<!-- [style.direction]="sideItem.name=='medicpatient' || sideItem.name=='nondrugpatient'?'ltr':''"
                                                      [style.align]="sideItem.name=='medicpatient' || sideItem.name=='nondrugpatient'?'left !important':'right'" -->
				}
			</div>
		}
	</div>
}
@switch (modalProps?.name) {
	@case ("reports") {
		<app-reports
			isModalMode
			(onClose)="modalProps = null"
			[report_name]="modalProps.report_name"
			filterFieldName="item_id"
			[filterFieldValue]="getPerson().id"
			[filterFieldShown]="getPerson().name"
			[item_type]="personType"
		/>
	}
	@case ("add-invoice") {
		<app-add-invoice
			(onClose)="handleAddInvoiceClose()"
			[description]="modalProps.description"
			[paid_by]="getPerson().name"
			[is_withholding_tax]="getPerson().is_withholding_tax"
			[withholding_tax_percent]="getPerson().withholding_tax_percent"
			[for]="getPerson().name"
			[resource]="personType"
			[resourceId]="getPerson().id"
		/>
	}
	@case ("image-gallery") {
		<app-image-gallery
			(onClose)="modalProps = null"
			[images]="modalProps.images"
		/>
	}
	@case ("test-graph") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="graphs"
		>
			<app-test-graph
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
				[test_id]="modalProps.test_id"
			/>
		</app-modal-wrap>
	}
	@case ("add-prescription") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="prescription"
			modalWrapperClass="modal-wide"
		>
			<app-add-prescription
				(onClose)="modalProps = null; handleAddPrescriptionClose($event)"
				[patient_id]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("tests-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="tests"
			modalWrapperClass="modal-small-width"
		>
			<app-tests-menu
				(onClose)="modalProps = null; refreshTestfills()"
				[patient_id]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("upload-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="upload_file"
		>
			<app-upload-document
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
				[followup_id]="$safeNavigationMigration(followup?.id)"
			/>
		</app-modal-wrap>
	}
	@case ("testschedules") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="testschedules"
		>
			<app-testschedules
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("patient-test-invites") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="test_invites_log"
		>
			<app-patient-test-invites
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("task") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-650"
			title="tasks"
		>
			<app-task
				(onClose)="modalProps = null"
				[patientRow]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
				[title]="modalProps.title"
				[followup]="modalProps.followup"
				[isMedicalLetter]="modalProps.isMedicalLetter"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-bankaccounts") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="bankaccounts"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="bankaccounts"
				filterField="patient_id"
				[filterFieldValue]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="
					modalProps = null; $event?.length && handleContactwaysClose($event)
				"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="patient.id"
				fieldNameInItemToDisplay="contactway"
				isCheckItems
				[filterFieldApiObject]="modalProps.filterFieldApiObject"
				[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
			/>
		</app-modal-wrap>
	}
}
@switch (requireCompProps?.name) {
	@case ("prescription") {
		<app-require-cc-field
			fieldName="prescription_signature"
			apiCall="update_prescription_signature"
			(onDone)="
				requireCompProps = null; handleRequirePrescriptionSigClsoe($event)
			"
		/>
	}
	@case ("defaultSignature") {
		<app-require-default-signature (onDone)="handleDefaultSigClose($event)" />
	}
}

<ng-template #backBtn>
	<button
		class="close back-to"
		tabindex="-1"
		[titleLang]="
			(isHome ? 'back_to_journal' : 'back_to_patient_details') | langVal
		"
		(click)="backToMain()"
		preIcon="modal-close"
	>
		<span class="back-to-details">{{
			(isHome ? "back_to_journal" : "back_to_patient_details") | langVal
		}}</span>
	</button>
</ng-template>
